<template>
    <div class="has-text-centered">
        <b-icon icon="circle-notch" size="is-large" custom-class="fa-spin"></b-icon>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>